import { ListStateInterface } from './list-state.interface';

export class PickerState implements ListStateInterface {
  public filter2DefaultSelectedContainerUuid: string;
  public filter2SelectedContainerUuid: string | null | undefined;
  public filter2SelectedSubcontainerUuid: string;
  public filterDefaultSelectedContainerUuid: string | null | undefined;
  public filterSelectedContainerUuid: string | null | undefined;
  public filterSelectedSubcontainerUuid: string | null | undefined;
  public pageIndex: number;
  public pageSize: number;
  public textFilter: string | null | undefined;
  public textFilter2: string | null;

  public constructor() {
    this.textFilter = '';
    this.textFilter2 = '';
    this.pageSize = 5;
    this.pageIndex = 0;
  }

  public isFilterSetToDefaultValues(): boolean {
    if (
      !this.textFilter &&
      !this.textFilter2 &&
      this.filterSelectedContainerUuid === this.filterDefaultSelectedContainerUuid &&
      !this.filterSelectedSubcontainerUuid &&
      (!this.pageIndex || this.pageIndex === 0)
    ) {
      return true;
    }

    return false;
  }
}
